<div class="page error-bg">
    <!-- Start::error-page -->
    <div class="error-page">
        <div class="container">
            <div class="my-auto">
                <div class="row align-items-center justify-content-center h-100">
                    <div class="col-xl-7 col-lg-5 col-md-6 col-12">
                        <p class="error-text mb-4">{{ 'error.not-found.code' | translate }}</p>
                        <p class="fs-4 fw-normal mb-2"> {{ 'error.not-found.title' | translate }}</p>
                        <p class="fs-15 mb-5 text-muted">{{ 'error.not-found.message' | translate }}</p>
                        <a routerLink="/main/home" class="btn btn-primary"><i class="ri-arrow-left-line align-middle me-1 d-inline-block"></i> {{ 'error.not-found.button-redirect' | translate }}</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
